<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden" style="width: 95%; margin: 0 auto;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        รายงานผล
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหารายงานผล" name="searchName"
      [(ngModel)]="search" (keyup)="searching()">
    <lifedi-btn lable="เพิ่มรายงานผล" (click)="addReport()" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <!-- not search -->
  <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allReport" nzBordered nzSize="large" class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสรายงานผล</th>
        <th class="text-center">ชื่อรายงานผล</th>
        <th class="text-center">ชื่อแบบทดสอบ</th>
        <th class="text-center">วันที่สร้าง</th>
        <th class="text-center" [nzFilters]="reportTypeFilter" [nzFilterFn]="filterReportTypeFn">รูปแบบรายงานผล</th>
        <th class="text-center" [nzFilters]="filterViewStatus" [nzFilterFn]="viewStatusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">แก้ไข</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let report of groupingTable.data;">
        <td class="text-center">{{ report.REPORT_ID }}</td>
        <td class="text-center">{{ report.REPORT_NAME }}</td>
        <td class="text-center">{{ report.MEASURE_NAME }}</td>
        <td class="text-center">{{ report.CREATE_DATE | date }}</td>
        <td class="text-center">
          <span *ngIf="report.STATUS === 'free'">รายงานผลเบื้องต้น</span>
          <span *ngIf="report.STATUS === 'paid'">รายงานผลเชิงลึก</span>
          <span *ngIf="report.STATUS === 'both'">รายงานผลเบื้องต้น/รายงานผลเชิงลึก</span>
          <span *ngIf="report.STATUS === 'not'">ยังไม่มีรายงานผล</span>
        </td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!report.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, report)">
          </mat-slide-toggle>
        </td>
        <td class="text-center">
          <a (click)="edit(report)" style="cursor: pointer;">
            <img src="assets/edit.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>


  <!-- search -->
  <nz-table *ngIf="isSearch" #groupingTable [nzData]="searchReport" nzBordered nzSize="large"
    class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสรายงานผล</th>
        <th class="text-center">ชื่อรายงานผล</th>
        <th class="text-center">ชื่อแบบทดสอบ</th>
        <th class="text-center">วันที่สร้าง</th>
        <th class="text-center" [nzFilters]="filterReportType" [nzFilterFn]="reportTypeFilterFn">รูปแบบรายงานผล</th>
        <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">แก้ไข</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let report of groupingTable.data;">
        <td class="text-center">{{ report.REPORT_ID }}</td>
        <td class="text-center">{{ report.REPORT_NAME }}</td>
        <td class="text-center">{{ report.MEASURE_NAME }}</td>
        <td class="text-center">{{ report.CREATE_DATE | date }}</td>
        <td class="text-center">
          <span *ngIf="report.STATUS === 'free'">รายงานผลเบื้องต้น</span>
          <span *ngIf="report.STATUS === 'paid'">รายงานผลเชิงลึก</span>
          <span *ngIf="report.STATUS === 'both'">รายงานผลเบื้องต้น/รายงานผลเชิงลึก</span>
          <span *ngIf="report.STATUS === 'not'">ยังไม่มีรายงานผล</span>
        </td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!report.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, report)">
          </mat-slide-toggle>
        </td>
        <td class="text-center">
          <a (click)="edit(report)" style="cursor: pointer;">
            <img src="assets/edit.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
